import { RoverBrand } from '@rover/types/src/RoverBrand';

import getRoverBrandFromHostname from './getRoverBrandFromHostname';

const getRoverBrand = (): RoverBrand => {
  // `host`, not `hostname`: development serves each brand on its own port.
  return getRoverBrandFromHostname(window.location.host);
};

export default getRoverBrand;
